import { render, staticRenderFns } from "./bin-location-type.vue?vue&type=template&id=74943ff3"
import script from "./bin-location-type.vue?vue&type=script&lang=js"
export * from "./bin-location-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports